/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRecommendationViewResponse {
    getFixupPrototypeFunction() { return PolicyRecommendationViewResponse.fixupPrototype; }

    static newInstance(model: Partial<PolicyRecommendationViewResponse>): PolicyRecommendationViewResponse {
        let obj = Object.assign(new PolicyRecommendationViewResponse(), model);
        PolicyRecommendationViewResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRecommendationViewResponse>): PolicyRecommendationViewResponse {
        if (!model) return null;
        return PolicyRecommendationViewResponse.newInstance(<PolicyRecommendationViewResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRecommendationViewResponse) {
        if (!obj) return;

        models.PolicyRecommendationViewResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRecommendationViewResponse): boolean {
        Object.setPrototypeOf(obj, PolicyRecommendationViewResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.actions) {
            for (let val of this.actions) {
                models.RecommendationActionResponse.fixupPrototype(val);
            }
        }
        if (this.resources) {
            for (let val of this.resources) {
                models.ResourceRecommendationModel.fixupPrototype(val);
            }
        }
    }

    /**
     * unique recommendation Id
     */
    recommendation_id: string;

    /**
     * recommendation name
     */
    recommendation_name: string;

    /**
     * list of policy ids for which the recommendation exists
     */
    policy_id: Array<string>;

    /**
     * resolution status of the recommendation the values will be open, resolved
     */
    status: string;

    /**
     * impact of recommended changes
     */
    impact: string;

    /**
     * classified based on the kind of recommendation provided to the user can be cost, security etc
     */
    classification: string;

    /**
     * cloud account id impacted by the recommendation
     */
    cloud_account_id: string;

    /**
     * cloud on which this account exits for which the recommendations exists
     */
    cloud: string;

    /**
     * tenant for which the recommendation exits
     */
    tenant_name: string;

    /**
     * UTC time at which the recommendation was created
     */
    created_at: string;

    /**
     * Description about the recommendation in details
     */
    description: string;

    /**
     * List of actions which can be performed to resolve the policy violations
     */
    actions: Array<models.RecommendationActionResponse>;

    /**
     * List of resources on which the recommendations can be performed
     */
    resources: Array<models.ResourceRecommendationModel>;

}
